<template>
  <div>
<transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
  <div v-if="english" key="english">
    <div id="wrapper">
      <section id="main" class="wrapper">
        <div class="inner">
          <h1 class="major">Map <span class="lastname lastnameNoBorder">From GeoIP</span></h1>
          <span class="image fit">
            <iframe 
              :width="(isMobile) ? 300 : (larger ? 1400 : 720)"
              :height="(isMobile) ? 168 : (larger ? 787 : 405)"
              src="https://www.youtube.com/embed/OY_zhgDLkoU" 
              title="YouTube video player" 
              frameborder="0" 
              allowfullscreen
            ></iframe>
          </span>
        <p>
          The first project I was given during my apprenticeship at the rectorat de Versailles, very soberly called <code>map-from-geoip</code>, allowed to display a map where points appeared according to the received coordinates.
          The stack was composed as follows:
          <ul>
            <li>The front, generated with Express, displays the map with the open-source library Leaflet</li>
            <li>The back in NodeJS, communicates with the front via Socket.IO and allows the dynamism of the map</li>
            <li>Redis, only to use the Message Queue system, allows the communication with Logstash</li>
            <li>Logstash, a tool for collecting and storing logs, receives the logs via the UDP port, filters them to keep only the IPs, and applies a function to get the coordinates
            </li>
          </ul>
            To summarize how it works, we receive a log on the UDP port, this log is filtered to keep only the IP, then we apply a rule that returns the geographical data. This data is then published on a Redis channel. On the other side is our back-end in NodeJS, which is subbed to the same channel and then receives the data, and sends it directly via Socket.IO to the front-end, which, thanks to the Leaflet library, displays a marker on the map with that coordinates, to delete it 300 milliseconds later.
        </p>
      </div>
     </section> 
    </div>
  </div>
      <!-- --------------------- FRENCH --------------------- -->
  <div v-if="!english" key="french">
    <div id="wrapper">
      <section id="main" class="wrapper">
        <div class="inner">
          <h1 class="major">Map <span class="lastname lastnameNoBorder">From GeoIP</span></h1>
          <span class="image fit">
            <iframe 
                  :width="(isMobile) ? 300 : (larger ? 1400 : 720)"
                  :height="(isMobile) ? 168 : (larger ? 787 : 405)"
              src="https://www.youtube.com/embed/OY_zhgDLkoU" 
              title="YouTube video player" 
              frameborder="0" 
              allowfullscreen
            ></iframe>
          </span>
          <p>
            Le premier projet qui m'a été confié durant mon alternance au rectorat de Versailles, très sobrement
            appelé <code>map-from-geoip</code>, permettait d'afficher une carte où des
            points apparaissait selon les coordonnées reçues.
            La stack se composait de la manière suivante :
            <ul>
              <li>Le front, généré grâce à Express, affiche la carte grâce à la librairie open-source Leaflet
              </li>
              <li>Le back en NodeJS, communique avec le front via Socket.IO et permet le dynamisme de la
               carte</li>
              <li>Redis, uniquement pour utiliser le système de Message Queue, permet entre autres la
               communication avec Logstash</li>
              <li>Logstash, outil pour la collecte et le stockage de logs, reçoit les logs via le port UDP,
               les filtre pour ne garder que les IPs, et applique une fonction pour avoir les coordonnées
              </li>
            </ul>
            Pour résumer le fonctionnement, on reçoit un log sur le port UDP, ce log est filtré pour ne garder
            uniquement l'IP, puis on applique une règle qui retourne les données géographiques. Cette donnée est
            ensuite publiée sur un channel Redis. De l'autre côté se trouve notre back-end en NodeJS, qui est
            abonné au même channel et réceptionne donc la donnée, et l'envoie directement via Socket.IO au
            front-end, qui, grâce à la librairie Leaflet, affiche un point sur la carte avec les fameuses
            coordonnées, pour le supprimer 300 millisecondes après.
          </p>
       </div>
      </section>

        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  props: {
    larger: Boolean,
    english: Boolean,
    isMobile: Boolean,
  },
};
</script>
